import { z } from "zod";

/**
 * Feature request form validation schema
 */
export const featureRequestFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(5, "Title must be at least 5 characters")
    .max(200, "Title must be less than 200 characters"),
  
  description: z
    .string()
    .trim()
    .min(20, "Description must be at least 20 characters to provide adequate context")
    .max(1000, "Description must be less than 1000 characters"),
  
  category: z
    .string()
    .optional()
    .or(z.literal("")),
  
  user_email: z
    .string()
    .trim()
    .email("Please enter a valid email address")
    .max(255, "Email must be less than 255 characters")
    .toLowerCase()
    .optional()
    .or(z.literal("")),
});

export type FeatureRequestFormData = z.infer<typeof featureRequestFormSchema>;
